const SWIPER_SCRIPT_ID = 'carvue-swiper-script'

/** 与静态页 car/js/dist 一致的 Swiper 11，避免 npm swiper@5 与 bundle CSS 不兼容导致黑屏 */
function getSwiperScriptUrl() {
	if (process.env.NODE_ENV === 'development') {
		return '/car/js/dist/swiper-bundle.min.js'
	}
	const base = process.env.BASE_URL || '/'
	const prefix = base.endsWith('/') ? base : base + '/'
	return prefix + 'static/car/swiper-bundle.min.js'
}

export function loadCarSwiper() {
	if (typeof window !== 'undefined' && window.Swiper) {
		return Promise.resolve(window.Swiper)
	}
	return new Promise(function (resolve, reject) {
		const existing = document.getElementById(SWIPER_SCRIPT_ID)
		if (existing) {
			if (window.Swiper) {
				resolve(window.Swiper)
				return
			}
			existing.addEventListener('load', function () {
				window.Swiper ? resolve(window.Swiper) : reject(new Error('Swiper 未加载'))
			})
			existing.addEventListener('error', function () {
				reject(new Error('Swiper 脚本加载失败'))
			})
			return
		}
		const script = document.createElement('script')
		script.id = SWIPER_SCRIPT_ID
		script.src = getSwiperScriptUrl()
		script.async = true
		script.onload = function () {
			if (window.Swiper) resolve(window.Swiper)
			else reject(new Error('Swiper 未挂载到 window'))
		}
		script.onerror = function () {
			reject(new Error('Swiper 脚本加载失败: ' + script.src))
		}
		document.head.appendChild(script)
	})
}

export function removeCarSwiperScript() {
	const el = document.getElementById(SWIPER_SCRIPT_ID)
	if (el && el.parentNode) el.parentNode.removeChild(el)
}
